const DEFAULT_FORM_DATA = {
  product: {
    selectedProductUuid: "",
  },
};

export default DEFAULT_FORM_DATA;
